import { useCallback } from "react";
import { useIsMobile } from "./Screen";

export default function useScrollToElement({
  desktopOffset = 0,
  behavior = "smooth",
}: { desktopOffset?: number; behavior?: ScrollBehavior } = {}) {
  const isMobile = useIsMobile();
  return useCallback(
    // `onRest` is a callback function that will be called after the scroll action is considered complete.
    // For smooth scrolling, it is called after an approximate delay; for instant scroll, it is called immediately.
    (
      element: HTMLElement | null,
      options?: {
        // If provided, this will override the default offset calculation.
        offsetOverride?: number;
        onRest?: () => void;
        behavior?: ScrollBehavior;
      },
    ) => {
      if (element) {
        const effectiveBehavior = options?.behavior ?? behavior;
        const onRest = options?.onRest ?? (() => {});

        const offset =
          options?.offsetOverride ?? (isMobile ? 60 : desktopOffset);
        const y = element.offsetTop - offset;

        window.scrollTo({ top: y, behavior: effectiveBehavior });
        if (effectiveBehavior === "smooth") {
          setTimeout(onRest, 400); // Approximate scroll duration
        } else {
          onRest();
        }
      } else {
        options?.onRest?.();
      }
    },
    [isMobile, desktopOffset, behavior],
  );
}
